var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInicio(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 86,
    height: 79,
    viewBox: "0 0 86 79",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.2526 34.0945V73.3394C11.2526 74.0451 11.5558 74.7218 12.0955 75.2208C12.6352 75.7198 13.3672 76.0001 14.1305 76.0001H31.3981V53.3844C31.3981 52.3259 31.8529 51.3107 32.6625 50.5623C33.472 49.8138 34.5701 49.3933 35.715 49.3933H50.1046C51.2495 49.3933 52.3475 49.8138 53.1571 50.5623C53.9667 51.3107 54.4215 52.3259 54.4215 53.3844V76.0001H71.6891C72.4524 76.0001 73.1844 75.7198 73.7241 75.2208C74.2638 74.7218 74.567 74.0451 74.567 73.3394V34.0945",
    stroke: "#9597A7",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M83.4058 42.4372L44.9644 3.75516C44.0624 2.75398 41.9538 2.7426 41.0356 3.75516L2.59418 42.4372",
    stroke: "#9597A7",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M68.9751 27.837V6.03088H60.3167V19.1145",
    stroke: "#9597A7",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInicio);
export default __webpack_public_path__ + "static/media/inicio.a1c020c6aff16eaeb7ccfe638b665ba4.svg";
export { ForwardRef as ReactComponent };